import { Typography } from '@workspace/ui/components/Typography';
import { useBreakpoint } from '@workspace/ui/hooks/useBreakpoint';
import { ChevronDown24, ChevronRight16 } from '@workspace/ui/icons';
import { cn } from '@workspace/ui/lib/utils';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { orderStore, userStore } from '~/stores';

interface HeaderAddressButtonProps
  extends Omit<React.ComponentPropsWithoutRef<'div'>, 'children' | 'role'> {
  onClick: () => void;
}

export const HeaderAddressButton = observer<HeaderAddressButtonProps>(
  ({ className, ...props }) => {
    const { t } = useTranslation();
    const { isMobile } = useBreakpoint();

    return (
      <div
        {...props}
        role="button"
        className={cn(
          'flex w-full cursor-pointer items-center truncate text-graphic-regular-white transition-colors duration-300 group-data-[scrolled=true]:text-text-primary md:gap-1',
          className,
        )}
      >
        {isMobile ? (
          <>
            <div className="flex flex-col gap-px truncate">
              {orderStore.etaCalculation && userStore.deliveryAddress ? (
                <>
                  <Typography.Text100Medium className="truncate">
                    {userStore.deliveryAddress.address1}
                  </Typography.Text100Medium>
                  <Typography.Text100Semibold>
                    {userStore.deliveryAddress.zip}
                  </Typography.Text100Semibold>
                </>
              ) : (
                <Typography.Text100Semibold>
                  {t('phrases:selectDeliveryAddress')}
                </Typography.Text100Semibold>
              )}
            </div>
            <ChevronRight16 className="min-w-4" />
          </>
        ) : (
          <>
            <Typography.Text200Medium className="line-clamp-2 truncate">
              {orderStore.etaCalculation && userStore.deliveryAddress
                ? `${userStore.deliveryAddress.address1} ${userStore.deliveryAddress.zip}`
                : t('phrases:selectDeliveryAddress')}
            </Typography.Text200Medium>
            <ChevronDown24 className="min-w-6" />
          </>
        )}
      </div>
    );
  },
);
HeaderAddressButton.displayName = 'HeaderAddressButton';
